import { Modal, Button } from 'react-bootstrap';
import { useState } from 'react';
import { StepsContext } from '../context/StepsContext';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { container } from 'tsyringe';
import { SummaryService } from '@iq-solutions/nida-shared';
import { SummaryResults } from '@iq-solutions/nida-shared/src/services/summary';
import { UtilityComponent } from '@iq-solutions/nida-shared';
import { useParams } from 'react-router-dom';

type UrlParams = {
  drugs: Readonly<string>;
  risk: Readonly<string>;
};

const resultsComponent = (): JSX.Element => {
  const qContext = useContext(StepsContext);
  const urlParams = useParams<UrlParams>();
  const [summary, setSummary] = useState<Array<SummaryResults>>();
  const [show, setShow] = useState(true);
  const [results, setResults] = useState<SummaryResults>();
  let drugsIdentified: Array<string> = [];
  let tobaccoVal: { response: boolean; risk: string } = { response: false, risk: '' };
  let drugVal: { drug: Array<string>; score: number } = { drug: [], score: 0 };
  let riskScore = 'minimal';
  let max = 0;
  const sortedDrugs = [
    'Tobacco',
    'Alcohol',
    'Marijuana',
    'Prescription Drugs',
    'Inhalants',
    'K2 Spice',
  ];

  const riskScoreHandler = (score: number): string => {
    let risk = '';
    switch (true) {
      case score === 0:
        risk = 'minimal';
        break;
      case score === 1:
        risk = 'low';
        break;
      case score === 2:
        risk = 'high';
        break;
    }
    return risk;
  };

  useEffect(() => {
    setShow(qContext.userType === 'patient');
    const getQuestionsData = container.resolve(SummaryService);
    getQuestionsData
      .fetchQuestions(`${process.env.REACT_APP_HOST_API}/bstad-s2bi-summary`)
      .then((res: Array<SummaryResults>) => {
        setSummary(res);
      })
      .catch(() => {
        console.log('Failed to find date from https://nida.nih.gov/api/s2bi-s2bi-summary');
      });
  }, []);

  for (const value of Object.values(qContext.answers)) {
    let tempScore = 0;
    if (value.answer !== 'never' && drugsIdentified.indexOf(value.drugs) === -1) {
      drugsIdentified.push(value.drugs);
    }

    switch (value.answer) {
      case 'never':
        tempScore = 0;
        break;
      case 'once or twice':
        tempScore = 1;
        break;
      case 'monthly':
      case 'weekly or more':
        tempScore = 2;
        break;
    }
    if (value.drugs === 'Tobacco' && value.answer !== 'never') {
      tobaccoVal.response = true;
      tobaccoVal.risk = riskScoreHandler(tempScore);
    } else {
      tobaccoVal.response = false;
    }

    if (tempScore >= max) {
      drugVal.drug.push(value.drugs);
      drugVal.score = tempScore;
      max = tempScore;
    }
  }

  if (urlParams.drugs && urlParams.risk && urlParams.drugs !== '' && urlParams.risk !== '') {
    drugsIdentified = urlParams.drugs.replace(/-/g, ' ').split('+');
    drugVal.drug = [urlParams.drugs];
    riskScore = urlParams.risk;
    if (urlParams.drugs === 'Tobacco' && drugsIdentified.length === 1) {
      tobaccoVal.response = true;
      tobaccoVal.risk = urlParams.risk;
    } else {
      tobaccoVal.response = false;
    }
  } else {
    riskScore = riskScoreHandler(drugVal.score);
    drugsIdentified.sort(function (a, b): any {
      if (sortedDrugs.indexOf(a) > sortedDrugs.indexOf(b)) {
        return 1;
      } else if (sortedDrugs.indexOf(a) < sortedDrugs.indexOf(b)) {
        return -1;
      }
    });
  }

  useEffect(() => {
    if (summary) {
      let result = summary.find((res: SummaryResults) => {
        if (tobaccoVal.response) {
          return res.drug === 'Tobacco' && res.riskLevel.toLowerCase() === riskScore;
        } else {
          return res.drug !== 'Tobacco' && res.riskLevel.toLowerCase() === riskScore;
        }
      });
      setResults(result);
    }
  }, [summary, drugsIdentified.length]);

  const handleClose = (): void => setShow(false);

  return (
    <div className={show ? 'results-component hide' : 'results-component'}>
      <UtilityComponent
        app="s2bi"
        shareUrl={
          '/s2bi/result/riskLevel=' +
          riskScore +
          '&drugs=' +
          drugsIdentified.join('+').replace(/\s+/g, '-')
        }
      ></UtilityComponent>
      <div className="summary-header">
        <h2>Summary</h2>
      </div>
      <div className="summary-body">
        <div className="summary-results">
          <h3 className={'risk-score-' + riskScore}>
            {drugVal.drug[0] === 'Tobacco' && drugsIdentified.length === 1
              ? ''
              : 'Overall Risk Level: '}
            <span dangerouslySetInnerHTML={{ __html: results?.title! }}></span>
          </h3>
        </div>
        {drugsIdentified.length > 0 ? (
          <div className="drugs-identified">
            Drugs Identified: <p>{drugsIdentified.join(', ')}</p>
          </div>
        ) : null}
        {drugsIdentified.indexOf('Tobacco') > -1 && drugsIdentified.length !== 1 ? (
          <div className="more-info">
            <Link to={'/s2bi/result/riskLevel=' + riskScore + '&drugs=Tobacco'}>
              More Information About Tobacco
            </Link>
          </div>
        ) : null}
        <div
          className="drug-specific"
          dangerouslySetInnerHTML={{ __html: results?.description! }}
        ></div>

        <Modal show={show} className="results-modal">
          <Modal.Header>
            <Modal.Title>Thank You</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Thank you for taking this survey, please let your health care provider know that it is
              complete.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="link" onClick={handleClose}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default resultsComponent;
